import React, { FunctionComponent } from 'react';
import { Image } from '@chakra-ui/react';
import { useFormContext } from '../../../../hooks';
import { CalculatorBuyerCostsResultData } from './types';
import useMediaQuery from '../../../../hooks/use-media';
import { mainMediaMobile } from '../../../../utils';
import { assetPrefix } from '../../../../utils';
import { CalculatorBuyerCostsSummary } from './calculator-buyer-costs-summary';
import { FormattedMessage } from 'react-intl';

export const CalculatorsBuyerCostsCta: FunctionComponent = () => {
  const { result } = useFormContext<CalculatorBuyerCostsResultData>();
  const isMobile = useMediaQuery(mainMediaMobile);
  return (
    <div>
      <h2 className={`mb-0 md:mb-8`}>
        <FormattedMessage id={`cta.header`} defaultMessage={'Bereken kosten Koper'} />
      </h2>
      {!result && (
        <div className={`hidden md:block`}>
          <div>
            <FormattedMessage
              id={`cta.subheader`}
              defaultMessage={`Deze berekening geeft een indicatie van kosten koper, echter kan dit hoger of lager
              uitvallen aan de hand van de keuzes die je maakt en de uiteindelijke marktwaarde van de
              woning. Onze hypotheekadviseurs berekenen de kosten koper zodat je weet waar je aan toe
              bent.`}
            />
          </div>
          <Image w={`364px`} src={`${assetPrefix}/assets/shared/images/cta.png`}></Image>
        </div>
      )}
      {result && !isMobile && (
        <CalculatorBuyerCostsSummary result={result}></CalculatorBuyerCostsSummary>
      )}
    </div>
  );
};
